var map = {
	"./2021-01-christmas-tree-collection-banner.jpg": 1644,
	"./2021-01-christmas-tree-collection-thumbnail.jpg": 3156,
	"./2021-11-charity-quiz-night-banner.png": 5061,
	"./2021-11-charity-quiz-night-thumbnail.png": 5551,
	"./2022-11-charity-quiz-night-banner.png": 5526,
	"./2022-11-charity-quiz-night-thumbnail.png": 2926,
	"./2023-01-christmas-tree-collection-banner.jpg": 5299,
	"./2023-01-christmas-tree-collection-thumbnail.jpg": 5474,
	"./2023-11-charity-quiz-night-banner.png": 1775,
	"./2023-11-charity-quiz-night-thumbnail.png": 7838,
	"./2023-11-menfulness-quiz-night-banner.png": 9797,
	"./2023-11-menfulness-quiz-night-thumbnail.png": 4426,
	"./2024-01-christmas-tree-collection-banner.jpg": 8243,
	"./2024-01-christmas-tree-collection-thumbnail.jpg": 3185,
	"./2024-11-charity-quiz-night-banner.png": 5784,
	"./2024-11-charity-quiz-night-thumbnail.png": 5248,
	"./2025-11-charity-quiz-night-banner.png": 2978,
	"./2025-11-charity-quiz-night-thumbnail.png": 5610,
	"./2026-11-charity-quiz-night-banner.png": 6345,
	"./2026-11-charity-quiz-night-thumbnail.png": 9966,
	"./menfulness.png": 5041,
	"./trussell-trust.png": 4530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2500;